import { apiSlice } from "@/services/api-slice";
import { APIResponse } from "@/types/custom-http";
import { Role } from "./roles/roles.interface";
import { MenuItem } from "./modules/modules.interface";
import { Permissions } from "./permissions/permissions.interface";
import { SettingsAccessControl } from "./access-control.interface";
import { AclCatalogPageRow, DeleteGroupPagePermissionResult, GroupPagePermission, UpsertGroupPagePermissionPayload } from "./acl/acl.interface";

export const accessControlApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    getRoles: builder.query<APIResponse<Role[]>,void>({
        query: () => ({
          url: "auth/access-control/roles"
        }),
        providesTags: ["AccessControl"],
    }),

    getPermissions: builder.query<APIResponse<Permissions[]>,void>({
        query: () => ({
          url: "auth/access-control/permissions"
        }),
        providesTags: ["AccessControl"],
    }),

    getPermissionsRoles: builder.query<APIResponse<SettingsAccessControl>,void>({
        query: () => ({
          url: "auth/access-control/permissions-roles"
        }),
        providesTags: ["AccessControl"],
    }),

    getModules: builder.query<APIResponse<MenuItem[]>,void>({
        query: () => ({
          url: "auth/access-control/modules"
        }),
        providesTags: ["AccessControl"],
    }),

    getModulesByLevel: builder.query<APIResponse<MenuItem[]>,number>({
        query: (level) => ({
          url: `auth/access-control/modules/${level}`
        }),
        providesTags: ["AccessControl"],
    }),

    getAclPagesCatalog: builder.query<APIResponse<AclCatalogPageRow[]>, void>({
      query: () => ({
        url: "auth/access-control/acl/pages-catalog"
      }),
      providesTags: ["AccessControl"],
    }),

    getGroupPagePermissions: builder.query<APIResponse<GroupPagePermission[]>, number>({
      query: (groupId) => ({
        url: `auth/access-control/acl/groups/${groupId}/page-permissions`
      }),
      providesTags: (_result, _error, groupId) => [{ type: "AccessControl", id: `group-pages-${groupId}` }],
    }),

    upsertGroupPagePermission: builder.mutation<APIResponse<GroupPagePermission>, UpsertGroupPagePermissionPayload>({
      query: (body) => ({
        url: "auth/access-control/acl/group-page-permissions",
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, body) => [{ type: "AccessControl", id: `group-pages-${body.group_id}` }, "AccessControl"],
    }),

    deleteGroupPagePermission: builder.mutation<APIResponse<DeleteGroupPagePermissionResult>, { groupId: number; pageId: number }>({
      query: ({ groupId, pageId }) => ({
        url: `auth/access-control/acl/group-page-permissions/${groupId}/${pageId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, args) => [{ type: "AccessControl", id: `group-pages-${args.groupId}` }, "AccessControl"],
    }),

  }),

});


// Exportar hooks generados
export const {
  useGetRolesQuery,
  useLazyGetRolesQuery,
  useGetPermissionsQuery,
  useLazyGetPermissionsQuery,
  useGetPermissionsRolesQuery,
  useLazyGetPermissionsRolesQuery,
  useGetModulesQuery,
  useGetModulesByLevelQuery,
  useGetAclPagesCatalogQuery,
  useGetGroupPagePermissionsQuery,
  useUpsertGroupPagePermissionMutation,
  useDeleteGroupPagePermissionMutation
} = accessControlApi;
